import { IMainLayoutDomainStore } from '../../../../../layout/main/store/domain/IMainLayoutDomainStore';
import { inject } from '../../../../../../common/container/inject';
import { ILearningRootService, LearningRootServiceToken } from '../../../../../../service/LearningRootService';
import { IRootAdminService, RootAdminServiceToken } from '../../../../../../service/RootAdminService';
import { IAnalyticsUserDomain } from './IAnalyticsUserDomain';

export class AnalyticsUserDomain implements IAnalyticsUserDomain {
  constructor(
    _layoutDomain: IMainLayoutDomainStore,
    private rootAdminService = inject<IRootAdminService>(RootAdminServiceToken),
    private learningRootService = inject<ILearningRootService>(LearningRootServiceToken),
  ) {}

  getUserById = (userId: string) => this.rootAdminService.user.entity.getById(userId);

  getUserDetail = (userId: string) => this.learningRootService.report.getUserDetail(userId);
}
